import { takeLatest, put, throttle, select } from 'redux-saga/effects';
import {
  loadReferredPartnersIndexFailure,
  setReferredPartnersIndex,
  LOAD_INDEX,
  CHANGE_PAGINATOR_PAGE,
  setPaginatorTotal,
  SET_PER_PAGE_FILTER,
  ORDER_BY_PROCESSING_VOLUME,
  ORDER_BY_TRANSACTION_FEE,
  ORDER_BY_NUM_MERCHANTS,
  SET_SEARCH_FILTER,
  SET_CALENDAR_SAGA,
  DOWNLOAD_CSV,
  CLEAR_CALENDAR_FILTER
} from './reducer';
import { getRequest, handleSagaError } from '../../../utilities/requests';
import { handleLoadStatisticsSummary } from '../TableStatistics/sagas';
import { setReferredPartnerStatistics } from '../TableStatistics/reducer';
import {
  calculatePagination,
  orderBy,
  downloadCsv
} from '../../../utilities/misc';

export function* loadReferredPartnersIndexSaga() {
  yield takeLatest(
    [
      LOAD_INDEX,
      CHANGE_PAGINATOR_PAGE,
      SET_PER_PAGE_FILTER,
      ORDER_BY_PROCESSING_VOLUME,
      ORDER_BY_TRANSACTION_FEE,
      ORDER_BY_NUM_MERCHANTS,
      SET_SEARCH_FILTER,
      SET_CALENDAR_SAGA,
      CLEAR_CALENDAR_FILTER
    ],
    handleLoadReferredPartnersIndex
  );
}

const normalizeOrderByType = orderByType => {
  let type;
  switch (orderByType) {
    case 'total_processing_vol_usd':
      type = 'ProcessingVolume';
      break;
    case 'total_fees_usd':
      type = 'TransactionFee';
      break;
    case 'total_merchants':
      type = 'NumMerchants';
      break;
    default:
      break;
  }
  return `orderBy${type}State`;
};

function* handleOrderBy(orderByType) {
  const normalizedType = normalizeOrderByType(orderByType);
  const orderByState = yield select(
    state => state.partners.referredPartners.index[normalizedType]
  );
  return orderBy(orderByType, orderByState);
}

function* handleLoadReferredPartnersIndex(action) {
  try {
    const currentPage = yield select(
      state => state.partners.referredPartners.index.currentPage
    );
    const perPage = yield select(
      state => state.partners.referredPartners.index.perPageFilter
    );

    const calendarStart = yield select(
      state => state.partners.referredPartners.index.calendarStart
    );
    const calendarEnd = yield select(
      state => state.partners.referredPartners.index.calendarEnd
    );

    const orderByType = yield select(
      state => state.partners.referredPartners.index.orderByType
    );
    const searchValue = yield select(
      state => state.partners.referredPartners.index.searchValue
    );

    const orderConfig = yield handleOrderBy(orderByType);

    const config = {
      page: currentPage,
      per_page: perPage,
      include_stats: true,
      search: searchValue ? searchValue : null
    };

    Object.assign(config, { ...orderConfig });

    if (calendarEnd) {
      config.start_date = calendarStart.format('YY/MM/DD');
      config.end_date = calendarEnd.format('YY/MM/DD');
    }

    if (action.type === DOWNLOAD_CSV) {
      yield downloadCsv(action.path, null, config);
    } else {
      yield handleLoadReferredPartners(config);
    }
  } catch (error) {
    yield handleSagaError(
      error,
      'There was an error loading referred partner history.',
      loadReferredPartnersIndexFailure
    );
  }
}

function* handleLoadReferredPartners(config, perPage) {
  const url = '/referral_details';

  const response = yield getRequest(url, config);
  if (config.include_stats) {
    yield put(setReferredPartnerStatistics(response.data));
  }
  yield calculatePagination(
    response.data.total_referral_details,
    perPage,
    setPaginatorTotal
  );
  yield put(setReferredPartnersIndex(response.data));
  yield handleLoadStatisticsSummary();
}

export function* downloadReferredPartnersIndexCsvSaga() {
  yield throttle(5000, DOWNLOAD_CSV, handleLoadReferredPartnersIndex);
}
